<template>
   <div class="row yo-text-n white evento" :class="'device-'+$teras.app.device">


   <div class="row">
      <div class="col clear s6 ms yo-hidden-phone" ><div style="margin-top:60px;height:110px;border-left:3px solid grey;border-top:3px solid grey;">&#160;</div></div>
      <div class="col s12 m11m">

        <provider :evento="evento" :rowheight="evheight" ></provider>
        <div class="row">
          <div class="main col mm yo-hidden-phone" :style="'height:'+evheight+'px'">&#160;</div>
          <crediti :evento="evento" :rowheight="evheight" :info="false"></crediti>
          <titolo :evento="evento" :rowheight="evheight" v-on:change="val => evheight=val"></titolo>
        </div>

      </div>
      <div class="col s6 ms  yo-hidden-phone" ><div style="margin-top:60px;height:110px;border-right:3px solid grey;border-top:3px solid grey;">&#160;</div></div>   
   </div>

   <div class="row" style="clear:both;">
      


      <div class="col clear s6 ms yo-hidden-phone" ><div style="border-left:3px solid grey;height:210px;">&#160;</div></div>
      <div class="col s12 m11m">
         <div class="row ">
            
            <div class="info col s2 yo-align-center" ><img src="../assets/ico-obiettivi.png" style="height:50px;"/></div>
            <div class="col s10 " style="height:70px;color:#353535;">
               <div class="yo-text-bold">Obiettivi</div>
               <div v-html="evento.obiettivinome" ></div>
            </div>
            
         </div>


         <div class="row ">
            
            <div class="info col s2 yo-align-center" ><img src="../assets/ico-categoriaprofessionale.png" style="height:50px;"/></div>
            <div class="col s10 " style="height:70px;color:#353535;">
               <div class="yo-text-bold">Categoria Professionale</div>
               <div v-html="evento.categorianome" ></div>
            </div>
            
         </div>


         <div class="row ">
            
            <div class="info col s2 yo-align-center" ><img src="../assets/ico-disciplina.png" style="height:50px;"/></div>
            <div class="col s10 " style="height:70px;color:#353535;">
               <div class="yo-text-bold">Disciplina</div>
               <div v-html="evento.disciplinanome" ></div>
            </div>
            
         </div>


      </div>
      <div class="col s6 ms  yo-hidden-phone" ><div style="border-right:3px solid grey;height:210px;">&#160;</div></div>
      </div>

      <div class="col ss  yo-hidden-phone" ><div style="height:3px;border-left:3px solid grey;border-bottom:3px solid grey;">&#160;</div></div>
      <div class="col s11m  yo-hidden-phone" ><div style="height:3px;border-bottom:3px solid grey;">&#160;</div></div>
      <div class="col ss  yo-hidden-phone" ><div style="height:3px;border-right:3px solid grey;border-bottom:3px solid grey;">&#160;</div></div>

   </div>
</template>

<script>
import provider from './Evento-elenco-provider'
import crediti from './Evento-elenco-crediti'
import titolo from './Evento-elenco-titolo-res'
export default {
   props: {
      evento: Object
  },
  components: {
    provider
    ,crediti
    ,titolo
  },
  data(){
    return{
      evheight: 0
    }
  }
}
</script>


<style>
.mylogin-elenco-res .evento{
   padding: 0 20px;
   margin-bottom:20px;
}
.mylogin-elenco-res .provider{
   border-bottom:10px solid #379EC2;
   color:#353535;
   padding-bottom:4px !important;
}
.mylogin-elenco-res > .evento:nth-child(2n) .provider{
  border-bottom:10px solid #0E1C3C;
}
.mylogin-elenco-res .side{
   background: #379EC2;
   height:100px;
   padding:0 0 0 20px !important;
}
.mylogin-elenco-res  > .evento:nth-child(2n)  .side {
  background: #0E1C3C;
}
.mylogin-elenco-res .info div{
   background: #0E1C3C;
}
.mylogin-elenco-res  > .evento:nth-child(2n)  .info div{
  background: #379EC2;
}
.mylogin-elenco-res  .main{
   background: #379EC2;
   min-height:100px;
}.mylogin-elenco-res .device-desktop .main{
   height:100px;
   /*padding:0 0 0 20px !important; */
}.mylogin-elenco-res .device-mobile .main{
   padding-top:20px;
   margin-bottom:30px;
}
.mylogin-elenco-res  > .evento:nth-child(2n)  .main {
  background: #0E1C3C;
}




</style>



// WEBPACK FOOTER //
// src/components/Mylogin-elenco-ecm.vue